import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./HereToHelp.css";
import checkIcon from "../../../assets/img/aboutus/check.svg";
import aboutBackground from "../../../assets/img/contact/contact.svg";
import girls_boys from "../../../assets/img/contact/girls_boys.svg";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import GA from "../../functions/GA";
import selectCorrectUrls from "../../../selectCorrectUrls";

const HereToHelp = () => {
  const dispatch = useDispatch();
  const [responsiveStatus, setResponsiveStatus] = useState(false);
  const [activeTab, setActiveTab] = useState("policy");
  const [step, setStep] = useState(0);

  const [policyNumber, setPolicyNumber] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState();
  const [errorMessage, setErrorMessage] = useState();

  const [dateOfBirthMM, setDateOfBirthMM] = useState();
  const [dateOfBirthDD, setDateOfBirthDD] = useState();
  const [dateOfBirthYYYY, setDateOfBirthYYYY] = useState();
  const [stateForm, setStateForm] = useState("");
  const [policyPrefix, setPolicyPrefix] = useState("");
  const [insuredPhoneNumber, setInsuredPhoneNumber] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 480px)"),
      isMobile: window.matchMedia("(min-width: 481px) and (max-width: 767px)"),
      isTablet: window.matchMedia("(min-width: 768px) and (max-width: 1024px)"),
      isTabletLandscape: window.matchMedia(
        "(min-width: 1025px) and (max-width: 1279px)"
      ),
      isDesktop: window.matchMedia("(min-width: 1280px)"),
    };

    const updateResponsiveStatus = () => {
      const matchingBreakpoints = Object.entries(mediaQueries)
        .filter(([, mq]) => mq.matches)
        .map(([name]) => name);

      setResponsiveStatus(matchingBreakpoints[0]);
    };

    // Initial check
    updateResponsiveStatus();

    // Add media query listeners
    const mediaListeners = Object.values(mediaQueries).map((mq) => {
      mq.addEventListener("change", updateResponsiveStatus);
      return () => mq.removeEventListener("change", updateResponsiveStatus);
    });

    // Add window resize listener
    window.addEventListener("resize", updateResponsiveStatus);

    // Cleanup all listeners on unmount
    return () => {
      mediaListeners.forEach((remove) => remove());
      window.removeEventListener("resize", updateResponsiveStatus);
    };
  }, []);

  useEffect(() => {
    returnCorrectedDateforIE();
  }, [
    dateOfBirthMM,
    dateOfBirthDD,
    dateOfBirthYYYY,
    displayProperDOBforBrowser,
  ]);
  const [formData, setFormData] = useState({
    name: "",
    reason: "",
    email: "",
  });

  const [reasons] = useState([
    { label: "Make a change to my policy", value: "change_policy" },
    {
      label: "Need a verification of insurance for lienholder",
      value: "lien_holder",
    },
    {
      label: "Need verification of insurance for the state",
      value: "verification_state",
    },
    { label: "My policy is pending Cancellation", value: "pending_cancel" },
    { label: "I would like to cancel my policy", value: "cancel_policy" },
    {
      label: "My policy has a pending non-renewal",
      value: "pending_nonrenewal",
    },
    { label: "Make a payment", value: "make_a_payment" },
    { label: "Renew Policy", value: "renew_policy" },
    { label: "Other", value: "other" },
  ]);

  const numbersOnly = (string) => {
    const char = string[string.length - 1];

    if (
      char === "0" ||
      char === "1" ||
      char === "2" ||
      char === "3" ||
      char === "4" ||
      char === "5" ||
      char === "6" ||
      char === "7" ||
      char === "8" ||
      char === "9"
    ) {
      return true;
    } else return false;
  };

  function displayProperDOBforBrowser() {
    var properDateOfBirth = "";
    if (window.navigator.userAgent.indexOf("Trident") >= 0) {
      properDateOfBirth =
        padLeadingZeros(dateOfBirthMM, 2) +
        "/" +
        padLeadingZeros(dateOfBirthDD, 2) +
        "/" +
        dateOfBirthYYYY;
    } else {
      properDateOfBirth = dateOfBirth;
    }
    return properDateOfBirth;
  }

  function returnCorrectedDateforIE() {
    return (
      padLeadingZeros(dateOfBirthMM, 2) +
      "/" +
      padLeadingZeros(dateOfBirthDD, 2) +
      "/" +
      dateOfBirthYYYY
    );
  }

  function padLeadingZeros(num, size) {
    var s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  const handleSubmit = (e, currentStep) => {
    e.preventDefault();
    setErrorMessage("");
    if (currentStep === 1) {
      GA(
        "Needed_Assistance_Policy",
        `${policyNumber} tried to request assistance `
      );
      axios
        .post(
          `${
            selectCorrectUrls().quotePortal
          }/insurednew/insured/review/checkpolicy?policyNo=${policyNumber}&dob=${displayProperDOBforBrowser()}`
        )

        .then((response) => {
          setStateForm(response.data.state);
          setPolicyPrefix(response.data.prefix);
          setInsuredPhoneNumber(response.data.InsuredPhone);
          dispatch({
            type: "SET_AGENT_INFO",
            payload: {
              AgentName: response.data.agencyName,
              AgentPhone: response.data.agencyPhone,
            },
          });

          if (
            response.data.text === "OK" &&
            response.data.isDuplicate !== "Yes"
          ) {
            // dispatch({
            //   type: "SET_MESSAGE",
            //   payload: "Verified",
            // });
            // dispatch({
            //   type: "SET_INSURED_NUMBER",
            //   payload: response.data.InsuredPhone.substring(6, 10),
            // });

            // dispatch({
            //   type: "SET_SECCESS_MESSAGE",
            //   payload: true,
            // });
            setshowSearchModal(false);
            setSearchResultModal(true);
            setStateForm(response.data.state);
            setTimeout(() => {
              setStep(2);
            }, 2000);
          } else if (response.data.isDuplicate === "Yes") {
            GA(
              "Needed_Assistance_Duplicate",
              `${policyNumber} tried to request assistance twice `
            );
            // dispatch({
            //   type: "SET_MESSAGE",
            //   payload: "Request for assistance was already submitted.",
            // });
            // dispatch({
            //   type: "SET_ERROR_MESSAGE",
            //   payload: true,
            // });
          } else {
            setErrorMessage(response?.data?.text);
            // dispatch({
            //   type: "SET_MESSAGE",
            //   payload: "Invalid Data. Please try again",
            // });
            // dispatch({
            //   type: "SET_ERROR_MESSAGE",
            //   payload: true,
            // });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else if (currentStep === 2) {
      window.location =
        "https://account-management-claims-uaic-gwcpprod-prod.api.delta4-andromeda.guidewire.net/account-management-claims/tpp-claims";
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFinalSubmit = (e, step) => {
    e.preventDefault();
    // Add submit logic here
    axios
      .get(
        `${
          selectCorrectUrls().insuredPortal
        }/insurednew/insured/review/cconfirm?policyOrClaim=${
          policyPrefix + policyNumber
        }&returnedDate=${dateOfBirth}&csrName=${formData.name}&reasonFeedback=${
          formData.reason
        }&feedbackfor=U&phone=000&email=${
          formData.email
        }&relation=insured&statecode=${stateForm}`
      )
      .then((response) => {
        // console.log(response);
        // setRequestHelpTimerSeconds(5);
        // setIsRequestHelpTimerRunning(false);
        setLoading(false);

        // Here

        if (response.data.text === "OK") {
          // if (
          //   policySelect === "make_a_payment" ||
          //   policySelect === "renew_policy"
          // ) {
          //   window.location.replace(
          //     `${selectCorrectUrls().insuredPortal}/insurednew`
          //   );
          // } else if (policySelect === "lien_holder") {
          //   window.location.hash = `#/uaichome/requestedHelp?PorC=${
          //     stepOneValue === "claims" ? claimNumber : policyNumber
          //   }`;
          // } else {
          window.location.hash = `#/uaichome/requestedHelp?PorC=${policyNumber}`;
          // }

          setStep(0);
        } else {
          dispatch({
            type: "SET_MESSAGE",
            payload: response.data.text + ". Please try again",
          });
          dispatch({
            type: "SET_ERROR_MESSAGE",
            payload: true,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        setshowSearchModal(false);
        // Do something (e.g., close modal)
      }
    };

    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);
  const [showSearchModal, setshowSearchModal] = useState(false);
  const [showSearchResultModal, setSearchResultModal] = useState(false);
  const [showResponseModalText, setResponseModalText] = useState(false);

  return (
    <>
      {showSearchModal && (
        <div
          className="modal show fade d-block modal-blur"
          tabIndex="-1"
          role="dialog"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: "5em",
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{
              width:
                responsiveStatus === "isDesktop"
                  ? "auto"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "auto"
                  : "80%",

              // height : responsiveStatus ? '80%':'auto',
              maxWidth: "800px",
              margin: "1.75rem auto",
            }}
          >
            <div className="modal show d-block" tabIndex="-1" role="dialog">
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
                style={{
                  width:
                    responsiveStatus === "isDesktop"
                      ? "auto"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "auto"
                      : "80%",
                  maxWidth: "800px",
                  margin: "1.75rem auto",
                }}
              >
                <div
                  className="modal-content p-0"
                  style={{
                    borderRadius: "20px",
                    overflow: "hidden",
                    width:
                      responsiveStatus === "isDesktop"
                        ? "40%"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "40%"
                        : "100%",

                    // maxHeight: responsiveStatus ? '90vh' : '85%',
                    display: "flex",
                    flexDirection: "column",
                    margin: "auto",
                    // marginBottom: responsiveStatus ? '50vh' : 'auto'
                  }}
                >
                  {/* Modal Header */}
                  <div
                    style={styles.modalHeaderBar}
                    className="d-flex align-items-center justify-content-between px-3 px-md-4 py-3"
                  >
                    <h2
                      style={{
                        ...styles.modalHeading,
                        fontSize:
                          responsiveStatus === "isDesktop"
                            ? "20px"
                            : responsiveStatus === "isTablet" ||
                              responsiveStatus === "isTabletLandscape"
                            ? "20px"
                            : "18px",
                      }}
                      className="m-0"
                    >
                      How Can We Help?
                    </h2>
                    <button
                      className="btn-close"
                      style={styles.closeButton}
                      onClick={() => {
                        setshowSearchModal(false);
                        setDateOfBirth("");
                        setPolicyNumber("");
                      }}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div
                    className="d-flex flex-column flex-md-row"
                    style={{
                      // height: responsiveStatus?'100%':"265px",
                      overflow:
                        responsiveStatus === "isDesktop"
                          ? "visible"
                          : responsiveStatus === "isTablet" ||
                            responsiveStatus === "isTabletLandscape"
                          ? "visible"
                          : "auto",

                      padding: "20px 20px 20px 5px",
                    }}
                  >
                    {/* Left Sidebar */}
                    <div
                      className="sidebar"
                      style={{
                        ...styles.sidebar,
                        width:
                          responsiveStatus === "isDesktop"
                            ? "193px"
                            : responsiveStatus === "isTablet" ||
                              responsiveStatus === "isTabletLandscape"
                            ? "193px"
                            : "100%",
                        padding:
                          responsiveStatus === "isDesktop"
                            ? "20px 0 0 0"
                            : responsiveStatus === "isTablet" ||
                              responsiveStatus === "isTabletLandscape"
                            ? "20px 0 0 0"
                            : "16px 0",

                        borderRight:
                          responsiveStatus === "isDesktop"
                            ? "1px solid #e3e3e3"
                            : responsiveStatus === "isTablet" ||
                              responsiveStatus === "isTabletLandscape"
                            ? "1px solid #e3e3e3"
                            : "none",

                        borderBottom:
                          responsiveStatus === "isDesktop"
                            ? "none"
                            : responsiveStatus === "isTablet" ||
                              responsiveStatus === "isTabletLandscape"
                            ? "none"
                            : "1px solid #e3e3e3",

                        position:
                          responsiveStatus === "isDesktop"
                            ? "relative"
                            : responsiveStatus === "isTablet" ||
                              responsiveStatus === "isTabletLandscape"
                            ? "relative"
                            : "sticky",

                        top: 0,
                        backgroundColor: "#fff",
                        zIndex: 1,
                        marginTop:
                          responsiveStatus === "isDesktop" ||
                          responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                            ? "inherit"
                            : "-27px",
                      }}
                    >
                      <div
                        className={`sidebar-item${
                          activeTab === "policy" ? " active" : ""
                        }`}
                        style={{
                          ...styles.sidebarItem,
                          ...(activeTab === "policy"
                            ? styles.sidebarItemActive
                            : {}),
                        }}
                        onClick={() => setActiveTab("policy")}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.backgroundColor = "#dbe9f8")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            "transparent")
                        }
                      >
                        <span
                          style={{
                            ...(activeTab === "policy"
                              ? styles.sidebarTextActive
                              : {}),
                            fontSize:
                              responsiveStatus === "isDesktop"
                                ? "18px"
                                : responsiveStatus === "isTablet" ||
                                  responsiveStatus === "isTabletLandscape"
                                ? "18px"
                                : "16px",
                          }}
                        >
                          Policy
                        </span>
                      </div>
                      <div
                        className={`sidebar-item${
                          activeTab === "claims" ? " active" : ""
                        }`}
                        style={{
                          ...styles.sidebarItem,
                          ...(activeTab === "claims"
                            ? styles.sidebarItemActive
                            : {}),
                        }}
                        onClick={() => setActiveTab("claims")}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.backgroundColor = "#dbe9f8")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            "transparent")
                        }
                      >
                        <span
                          style={{
                            ...(activeTab === "claims"
                              ? styles.sidebarTextActive
                              : {}),
                            fontSize:
                              responsiveStatus === "isDesktop"
                                ? "18px"
                                : responsiveStatus === "isTablet" ||
                                  responsiveStatus === "isTabletLandscape"
                                ? "18px"
                                : "16px",
                          }}
                        >
                          Claims
                        </span>
                      </div>
                    </div>
                    {/* Right Content */}
                    <div
                      className="content"
                      style={{
                        ...styles.content,
                        padding: "16px",
                      }}
                    >
                      {activeTab === "policy" && (
                        <div className="policy-section">
                          <div className="mb-3" style={{ textAlign: "left" }}>
                            <label
                              className="form-label"
                              style={{ fontWeight: 600, fontSize: "14px" }}
                            >
                              Policy Number
                            </label>
                            <input
                              style={{
                                fontSize: "14px",
                                color: "#A09999",
                              }}
                              onChange={(e) => setPolicyNumber(e.target.value)}
                              type="text"
                              className="form-control"
                              placeholder="Policy#"
                              onKeyDown={(e) => {
                                const isLetterOrNumber = /^[0-9]$/.test(e.key);
                                const allowedControlKeys = [
                                  "Backspace",
                                  "Tab",
                                  "ArrowLeft",
                                  "ArrowRight",
                                  "Delete",
                                ];

                                if (
                                  !isLetterOrNumber &&
                                  !allowedControlKeys.includes(e.key)
                                ) {
                                  e.preventDefault(); // Block everything else
                                }
                              }}
                            />
                          </div>
                          <div
                            className="mb-3"
                            style={{
                              textAlign: "left",
                            }}
                          >
                            <label
                              className="form-label"
                              style={{ fontWeight: 600, fontSize: "14px" }}
                            >
                              D.O.B
                            </label>
                            <div
                              style={{
                                border:
                                  dateOfBirth &&
                                  /^\d{4}-\d{2}-\d{2}$/.test(dateOfBirth) && // ensure full date format
                                  new Date(dateOfBirth).getFullYear() <= 1925 &&
                                  new Date(dateOfBirth).getFullYear() >= 1900
                                    ? "2px solid red"
                                    : "",
                              }}
                            >
                              <input
                                style={{
                                  fontSize: "14px",
                                  color: "#A09999",
                                }}
                                type="date"
                                // value={dateOfBirth}
                                onChange={(e) => setDateOfBirth(e.target.value)}
                                className="form-control"
                                placeholder="mm-dd-yyyy"
                                max="9999-12-31"
                              />
                            </div>
                          </div>
                          <p style={{ color: "red", marginTop: "0px" }}>
                            {errorMessage}
                          </p>
                          <button
                            onClick={(e) => handleSubmit(e, 1)}
                            className="btn btn-primary-continue mt-2 w-100"
                            disabled={
                              !dateOfBirth ||
                              !policyNumber ||
                              (dateOfBirth &&
                                /^\d{4}-\d{2}-\d{2}$/.test(dateOfBirth) && // ensure full date format
                                new Date(dateOfBirth).getFullYear() <= 1925)
                            }
                            style={{
                              padding: "8px 16px",
                              fontWeight: 500,
                              fontSize:
                                responsiveStatus === "isDesktop"
                                  ? "18px"
                                  : responsiveStatus === "isTablet" ||
                                    responsiveStatus === "isTabletLandscape"
                                  ? "18px"
                                  : "16px",
                            }}
                          >
                            Continue
                          </button>
                        </div>
                      )}
                      {activeTab === "claims" && (
                        <div className="claims-section">
                          {/* <div className="mb-3" style={{ textAlign: "left" }}>
                              <label
                                className="form-label"
                                style={{ fontWeight: 600, fontSize: '14px' }}
                              >
                                Claim Number
                              </label>
                              <input
                              style={{
                                fontSize:'14px',
                                color:'#A09999'
                              }}
                                type="text"
                                className="form-control"
                                placeholder="Policy#"
                              />
                            </div>
                            <div className="mb-3" style={{ textAlign: "left" }}>
                              <label
                                className="form-label"
                                style={{ fontWeight: 600, fontSize: '14px' }}
                              >
                                Date of Loss
                              </label>
                              <input
                              style={{
                                fontSize:'14px',
                                color:'#A09999'
                              }}
                                type="date"
                                className="form-control"
                                placeholder="mm-dd-yyyy"
                              />
                            </div> */}
                          <a
                            href="https://account-management-claims-uaic-gwcpprod-prod.delta4-andromeda.guidewire.net/account-management-claims/tpp-claims"
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-primary-continue w-100 mt-2"
                            style={{
                              fontWeight: 500,
                              fontSize:
                                responsiveStatus === "isDesktop"
                                  ? "18px"
                                  : responsiveStatus === "isTablet" ||
                                    responsiveStatus === "isTabletLandscape"
                                  ? "18px"
                                  : "16px",
                            }}
                          >
                            Continue
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </div>
      )}
      <div
        className="py-5"
        style={
          responsiveStatus === "isDesktop"
            ? styles.container
            : responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
            ? styles.container
            : styles.container1
        }
      >
        <Container
          style={{
            marginLeft:
              responsiveStatus === "isDesktop"
                ? ""
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "0px"
                : "",
            maxWidth:
              responsiveStatus === "isDesktop"
                ? "1300px"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "1300px"
                : "",
            margin: "0 auto",
          }}
        >
          <Row
            className="align-items-center"
            style={{
              position: "relative",
              left: 0,
              marginLeft: "0px",
              maxWidth:
                responsiveStatus === "isDesktop"
                  ? ""
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "475px"
                  : "475px",
            }}
          >
            {/* Left Column: Text Content */}
            <Col lg={6}>
              <p
                style={{
                  color: "#17252E",
                  fontSize: "16px",
                  lineHeight: "140%",
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                  position: "relative", // required for ::after
                  display: "inline-block",
                }}
              >
                <span
                  style={{
                    position: "relative",
                    paddingBottom: "5px",
                  }}
                >
                  Here to Help – Anytime, Anywhere
                  <span
                    style={{
                      content: '""',
                      position: "absolute",
                      left: 0,
                      bottom: -4,
                      height: "1.6px",
                      width: "35%", // Extend beyond text
                      backgroundColor: "#0e72d6",
                      transform: "translateX(0%)", // Centered extension
                    }}
                  />
                </span>
              </p>

              <h2
                className="mt-2"
                style={{
                  color: "#17252E",
                  lineHeight: "1",
                  fontWeight: "bold",
                  fontSize: "40px",
                  marginBottom: "1em",
                }}
              >
                We're Just a Call, Click, or Visit Away
              </h2>

              <p className="mb-4 text-secondary">
                We're here to help with all your questions, concerns, or
                feedback. Whether you need assistance with your policy, claims,
                or anything else, our friendly support team is just a call,
                click, or visit away. Your satisfaction is our priority, and
                we're committed to providing fast, reliable, and personalized
                service every time.
              </p>

              <div className="d-flex flex-wrap gap-3">
                <ul
                  className={
                    responsiveStatus === "isDesktop"
                      ? "d-flex flex-wrap gap-3"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "d-flex flex-wrap gap-3"
                      : "d-block flex-wrap gap-1"
                  }
                  style={{ listStyle: "none", padding: 0, margin: 0 }}
                >
                  {["Drop Us a Line", "Stop By Anytime", "Give Us a Ring"].map(
                    (item, i) => (
                      <li
                        key={i}
                        style={{
                          marginBottom: "12px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={checkIcon}
                          alt="check"
                          style={{ width: "20px", marginRight: "10px" }}
                        />
                        <span className="aboutTextStyle">{item}</span>
                      </li>
                    )
                  )}
                </ul>
              </div>
              <button
                className="btn btn-primary-Help mt-2"
                style={{ fontWeight: 500, fontSize: "18px" }}
                onClick={() => setshowSearchModal(true)}
              >
                Get Assistance
              </button>

              {responsiveStatus === "isMobile" ||
                (responsiveStatus === "isSmallMobile" && (
                  <div style={{ textAlign: "center", width: "100%" }}>
                    <img src={girls_boys} alt="girls_boys image" />
                  </div>
                ))}
            </Col>
          </Row>
        </Container>
      </div>

      {showSearchResultModal && (
        <div
          className="modal show fade d-block modal-blur"
          tabIndex="-1"
          role="dialog"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: "5em",
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{
              width:
                responsiveStatus === "isDesktop"
                  ? "auto"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "auto"
                  : "80%",
              // height : responsiveStatus ? '80%':'auto',
              maxWidth: "800px",
              margin: "1.75rem auto",
            }}
          >
            <div className="modal show d-block" tabIndex="-1" role="dialog">
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
                style={{
                  width:
                    responsiveStatus === "isDesktop"
                      ? "auto"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "auto"
                      : "80%",
                  maxWidth: "800px",
                  margin: "1.75rem auto",
                }}
              >
                <div
                  className="modal-content p-0"
                  style={{
                    borderRadius: "20px",
                    overflow: "hidden",
                    width:
                      responsiveStatus === "isDesktop"
                        ? "30%"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "30%"
                        : "100%",

                    // maxHeight: responsiveStatus ? '90vh' : '85%',
                    display: "flex",
                    flexDirection: "column",
                    margin: "auto",
                    // marginBottom: responsiveStatus ? '50vh' : 'auto'
                  }}
                >
                  {/* Modal Header */}
                  <div
                    style={styles.modalHeaderBar}
                    className="d-flex align-items-center justify-content-between px-3 px-md-4 py-3"
                  >
                    <h2
                      style={{
                        ...styles.modalHeading,
                        fontSize:
                          responsiveStatus === "isDesktop"
                            ? "20px"
                            : responsiveStatus === "isTablet" ||
                              responsiveStatus === "isTabletLandscape"
                            ? "20px"
                            : "18px",
                      }}
                      className="m-0"
                    >
                      Policy related:
                    </h2>
                    <button
                      className="btn-close"
                      style={styles.closeButton}
                      onClick={() => {
                        setSearchResultModal(false);
                        setshowSearchModal(true);
                      }}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div
                    className="d-flex flex-column flex-md-row"
                    style={{
                      // height: responsiveStatus?'100%':"265px",
                      overflow:
                        responsiveStatus === "isDesktop"
                          ? "visible"
                          : responsiveStatus === "isTablet" ||
                            responsiveStatus === "isTabletLandscape"
                          ? "visible"
                          : "auto",
                    }}
                  >
                    {/* Right Content */}
                    <form onSubmit={(e) => handleFinalSubmit(e, 1)}>
                      <div
                        className="content"
                        style={{
                          ...styles.content,
                          padding: "16px",
                        }}
                      >
                        <div className="policy-section">
                          <div className="mb-3" style={{ textAlign: "left" }}>
                            <label
                              className="form-label"
                              style={{ fontWeight: 600, fontSize: "14px" }}
                            >
                              Name
                            </label>
                            <input
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              style={{ fontSize: "14px", color: "#A09999" }}
                              type="text"
                              className="form-control"
                              placeholder="Name*"
                              required
                            />
                          </div>
                          <div className="mb-3" style={{ textAlign: "left" }}>
                            <label
                              className="form-label"
                              style={{ fontWeight: 600, fontSize: "14px" }}
                            >
                              Reason:
                            </label>
                            <select
                              name="reason"
                              value={formData.reason}
                              onChange={handleChange}
                              className="custom-select"
                              style={{
                                fontSize: "14px",
                                color: formData.reason ? "#000" : "#A09999",
                                appearance: "none", // hide default arrow in some browsers
                                background: `url("data:image/svg+xml;utf8,<svg fill='%23000' height='18' viewBox='0 0 24 24' width='18' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>") no-repeat right 10px center`,
                                backgroundColor: "#fff",
                                backgroundSize: "18px 18px",
                                paddingRight: "32px", // space for arrow
                                cursor: "pointer",
                              }}
                            >
                              <option value="" disabled hidden>
                                Please select a reason
                              </option>
                              {reasons.map((reason, index) => (
                                <option key={index} value={reason.value}>
                                  {reason.label}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="mb-3" style={{ textAlign: "left" }}>
                            <label
                              className="form-label"
                              style={{ fontWeight: 600, fontSize: "14px" }}
                            >
                              Email:
                            </label>
                            <input
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              style={{ fontSize: "14px", color: "#A09999" }}
                              type="email"
                              className="form-control"
                              placeholder="Email*"
                              required
                            />
                          </div>

                          <button
                            type="submit"
                            className="btn btn-primary-continue mt-2 w-100"
                            style={{
                              padding: "8px 16px",
                              fontWeight: 500,
                              fontSize:
                                responsiveStatus === "isDesktop"
                                  ? "18px"
                                  : responsiveStatus === "isTablet" ||
                                    responsiveStatus === "isTabletLandscape"
                                  ? "18px"
                                  : "16px",
                            }}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </div>
      )}
      {showResponseModalText && (
        <div
          className="modal show fade d-block modal-blur"
          tabIndex="-1"
          role="dialog"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: "5em",
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{
              width:
                responsiveStatus === "isDesktop"
                  ? "auto"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "auto"
                  : "80%",

              // height : responsiveStatus ? '80%':'auto',
              maxWidth: "800px",
              margin: "1.75rem auto",
            }}
          >
            <div className="modal show d-block" tabIndex="-1" role="dialog">
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
                style={{
                  width:
                    responsiveStatus === "isDesktop"
                      ? "auto"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "auto"
                      : "80%",
                  maxWidth: "800px",
                  margin: "1.75rem auto",
                }}
              >
                <div
                  className="modal-content p-0"
                  style={{
                    borderRadius: "20px",
                    overflow: "hidden",
                    width:
                      responsiveStatus === "isDesktop"
                        ? "30%"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "30%"
                        : "100%",
                    // maxHeight: responsiveStatus ? '90vh' : '85%',
                    display: "flex",
                    flexDirection: "column",
                    margin: "auto",
                    // marginBottom: responsiveStatus ? '50vh' : 'auto'
                  }}
                >
                  {/* Modal Header */}
                  <div
                    style={styles.modalHeaderBar}
                    className="d-flex align-items-center justify-content-between px-3 px-md-4 py-3"
                  >
                    {/* <h2
                      style={{
                        ...styles.modalHeading,
                        fontSize: responsiveStatus ? "18px" : "20px",
                      }}
                      className="m-0"
                    >
                      Policy related:
                    </h2> */}
                    <button
                      className="btn-close"
                      style={styles.closeButton}
                      onClick={() => {
                        setResponseModalText(false);
                      }}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div
                    className="d-flex flex-column flex-md-row"
                    style={{
                      // height: responsiveStatus?'100%':"265px",
                      overflow:
                        responsiveStatus === "isDesktop"
                          ? "visible"
                          : responsiveStatus === "isTablet" ||
                            responsiveStatus === "isTabletLandscape"
                          ? "visible"
                          : "auto",
                    }}
                  >
                    {/* Right Content */}

                    <div
                      className="content"
                      style={{
                        ...styles.content,
                        padding: "16px",
                      }}
                    >
                      <div className="policy-section">
                        <p>Hello</p>

                        <button
                          onClick={(e) => setResponseModalText(false)}
                          type="submit"
                          className="btn btn-primary-continue mt-2 w-100"
                          style={{
                            padding: "8px 16px",
                            fontWeight: 500,
                            fontSize:
                              responsiveStatus === "isDesktop"
                                ? "18pxt"
                                : responsiveStatus === "isTablet" ||
                                  responsiveStatus === "isTabletLandscape"
                                ? "18px"
                                : "16px",
                          }}
                        >
                          Ok
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </div>
      )}
    </>
  );
};
const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    // minHeight: "538px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${aboutBackground})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  container1: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    // minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    background: "linear-gradient(to bottom, #E2F6FC, #FFFFFF)",
  },
  modalHeaderBar: {
    width: "100%",
    background: "#f4f9ff",
    borderBottom: "1px solid #e3e3e3",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    // minHeight: "60px",
    position: "relative",
    zIndex: 2,
  },

  modalHeading: {
    fontWeight: 600,
    fontSize: "20px",
    color: "#000000",
  },
  closeButton: {
    fontSize: "1rem",
    cursor: "pointer",
    opacity: 1,
  },
  sidebar: {
    width: "220px",
    backgroundColor: "#fff",
    padding: "32px 0 0 0",
    borderRight: "1px solid #e3e3e3",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  sidebarItem: {
    width: "100%",
    padding: "5px 32px",
    cursor: "pointer",
    fontWeight: 400,
    fontSize: "18px",
    color: "#302f2f",
    background: "transparent",
    border: "none",
    outline: "none",
    textAlign: "left",
    transition: "background 0.2s, color 0.2s",
    borderRadius: "10px",
    // marginTop: "3px",
  },
  sidebarItemActive: {
    color: "#0e72d6",
    fontWeight: 500,
  },
  sidebarTextActive: {
    color: "#0e72d6",
    fontWeight: 500,
  },
  content: {
    flex: 1,
    // padding: '40px 40px 32px 40px',
    position: "relative",
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
};
export default HereToHelp;
